import type { IFrontLogger } from "@whatslly/commons/frontLogger/types";

export class ApiError extends Error {
  public readonly status: number;

  constructor(
    message: string,
    public readonly response: Response
  ) {
    super(message);
    this.status = response.status;
  }
}

function getApiErrorMessage(body: unknown): string | undefined {
  if (typeof body !== "object" || body === null || !("error" in body)) {
    return undefined;
  }
  const { error } = body;
  return typeof error === "string" ? error : undefined;
}

export async function parseOrReturnError<T>(response: Response, logger: Pick<IFrontLogger, "error">): Promise<T> {
  try {
    if (response.ok) {
      return (await response.json()) as T;
    }

    let message = `Unknown error: ${response.status}`;
    if (response.headers.get("content-type")?.includes("application/json")) {
      const body: unknown = await response.json();
      const apiError = getApiErrorMessage(body);
      message = `${apiError ?? "Unknown error"}: ${response.status}`;
    }
    throw new ApiError(message, response);
  } catch (error) {
    logger.error({ err: error }, "API request failed");
    throw error;
  }
}
